import { all } from 'redux-saga/effects';

import authSaga from './auth.saga';
import administrationSaga from './administration.saga';
import newsSaga from './news.saga';
import languagesSaga from './languages.saga';
import usersSaga from './users.saga';
import dictionariesSaga from './dictionaries.saga';
import complaintsSaga from './complaints.saga';
import contentSaga from './content.saga';
import dashBoardSaga from './dashboard.saga';
import settingsSaga from './settings.saga';
import keyWordsSaga from './keyWords.saga';
import violationSaga from './violation.saga';
import radarSaga from './radar.saga';
import locationsSaga from './locations.saga';
import giftsSaga from './gifts.saga';
import packagesSaga from './packages.saga';
import paidServicesSaga from './paidServices.saga'
import chatsSaga from './chats.saga';
import jjFortuneSaga from './jjFortune.saga';

export default function* rootSaga() {
  yield all([
    authSaga(),
    administrationSaga(),
    newsSaga(),
    languagesSaga(),
    usersSaga(),
    dictionariesSaga(),
    complaintsSaga(),
    contentSaga(),
    dashBoardSaga(),
    settingsSaga(),
    keyWordsSaga(),
    locationsSaga(),
    violationSaga(),
    radarSaga(),
    giftsSaga(),
    packagesSaga(),
    paidServicesSaga(),
    chatsSaga(),
    jjFortuneSaga(),
  ]);
}
